import { defineComponent as d, openBlock as t, createElementBlock as o, mergeProps as h, unref as e, renderSlot as p, createElementVNode as n, createCommentVNode as u } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, g = { key: 1 }, Z = { key: 2 }, M = { key: 3 }, f = { key: 4 }, k = { key: 5 }, A = {
  name: "ScalarIconBracketsSquare"
}, _ = /* @__PURE__ */ d({
  ...A,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: l } = i(r);
    return (V, a) => (t(), o("svg", h({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      p(V.$slots, "default"),
      e(l) === "bold" ? (t(), o("g", m, a[0] || (a[0] = [
        n("path", { d: "M52,52V204H80a12,12,0,0,1,0,24H40a12,12,0,0,1-12-12V40A12,12,0,0,1,40,28H80a12,12,0,0,1,0,24ZM216,28H176a12,12,0,0,0,0,24h28V204H176a12,12,0,0,0,0,24h40a12,12,0,0,0,12-12V40A12,12,0,0,0,216,28Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (t(), o("g", g, a[1] || (a[1] = [
        n("path", {
          d: "M216,40V216H40V40Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M48,48V208H80a8,8,0,0,1,0,16H40a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8H80a8,8,0,0,1,0,16ZM216,32H176a8,8,0,0,0,0,16h32V208H176a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Z" }, null, -1)
      ]))) : e(l) === "fill" ? (t(), o("g", Z, a[2] || (a[2] = [
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM104,176a8,8,0,0,1,0,16H72a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H80v96Zm88,8a8,8,0,0,1-8,8H152a8,8,0,0,1,0-16h24V80H152a8,8,0,0,1,0-16h32a8,8,0,0,1,8,8Z" }, null, -1)
      ]))) : e(l) === "light" ? (t(), o("g", M, a[3] || (a[3] = [
        n("path", { d: "M46,46V210H80a6,6,0,0,1,0,12H40a6,6,0,0,1-6-6V40a6,6,0,0,1,6-6H80a6,6,0,0,1,0,12ZM216,34H176a6,6,0,0,0,0,12h34V210H176a6,6,0,0,0,0,12h40a6,6,0,0,0,6-6V40A6,6,0,0,0,216,34Z" }, null, -1)
      ]))) : e(l) === "regular" ? (t(), o("g", f, a[4] || (a[4] = [
        n("path", { d: "M48,48V208H80a8,8,0,0,1,0,16H40a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8H80a8,8,0,0,1,0,16ZM216,32H176a8,8,0,0,0,0,16h32V208H176a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Z" }, null, -1)
      ]))) : e(l) === "thin" ? (t(), o("g", k, a[5] || (a[5] = [
        n("path", { d: "M44,44V212H80a4,4,0,0,1,0,8H40a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4H80a4,4,0,0,1,0,8Zm172-8H176a4,4,0,0,0,0,8h36V212H176a4,4,0,0,0,0,8h40a4,4,0,0,0,4-4V40A4,4,0,0,0,216,36Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  _ as default
};
